import { PERFORMANCE_DEFAULT_DATES } from 'constants';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  dateFilter: {
    filterType: PERFORMANCE_DEFAULT_DATES.today,
  },
};

const managerDateFilter = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.PERF_SET_PERFORMANCE_DATE_FILTER:
      return { dateFilter: payload };
    case actionTypes.PERF_CLEAR_PERFORMANCE_DATE_FILTER:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default managerDateFilter;
